import { Header as PtHeader } from 'patsnap-biz';
import { Site, SLD } from '@patsnap-utils/biz';
import { get } from 'lodash';
import LogoPatSnap from '@patsnap-biz/header/src/logos/PatSnap.vue';
import { handleLogout } from '@patsnap-utils/passport';
import PtHeaderWidgetCaseTime from '@patsnap-biz/header-widget-case-time';
import '@patsnap-biz/header-widget-case-time/lib/style';
import { psAxios } from '@patsnap/common-ps-http';
import { ACCOUNT_SERVICE_URI } from 'library-@/config/apiConfig';
import { generateHelpLink } from '@home/shared/utils/get-help-center-link';

export default {
    components: {
        PtHeader,
        LogoPatSnap,
        PtHeaderWidgetCaseTime
    },
    data() {
        const caseTimeService = new PtHeaderWidgetCaseTime.Service();
        caseTimeService.axios = psAxios;
        caseTimeService.accountServiceUrl = ACCOUNT_SERVICE_URI;
        return {
            caseTimeService
        };
    },
    methods: {
    },
    created() {
        const vm = this;
        const { locales } = this.headerService;
        this.headerService.locales = locales.map(({ active, ...rest }) => {
            return {
                ...rest,
                active: rest.key === this.$i18n.locale
            };
        });

        // 白名单不需要logo
        if (this.headerService.whiteLabel) this.headerService.logo = false;
        // 设置主页跳转链接
        this.headerService.logoHref = new Site({ sld: SLD.HOME }).href;

        // 根据不同区域设置帮助中心
        const region = get(this.headerService, 'account._info.site_region');
        let helpCenter = {
            icon: 'HelpCenter',
            trigger: 'hover',
            menu: [
                {
                    icon: 'SolidHelpCentre',
                    href: new Site({ sld: SLD.HELP, pathname: 'help' }).href,
                    label: vm.$t('snapBusiness.headerV2.growth.helpCenter')
                },
                null,
                {
                    icon: 'Term',
                    href: 'https://www.zhihuiya.com/legal/terms',
                    label: vm.$t('snapBusiness.headerV2.growth.terms')
                },
                {
                    icon: 'Privacy',
                    href: 'https://www.zhihuiya.com/legal/privacy',
                    label: vm.$t('snapBusiness.headerV2.growth.policy')
                }
            ]
        };
        if (region !== 'CN') {
            helpCenter = {
                icon: 'HelpCenter',
                trigger: 'hover',
                menu: [
                    {
                        icon: 'SolidHelpCentre',
                        label: vm.$t('snapBusiness.headerV2.growth.helpCenter'),
                        href: generateHelpLink(region.toLowerCase())
                    },
                    // {
                    //     icon: 'SolidUsers',
                    //     href: 'https://help.patsnap.com/hc/en-us/community/topics',
                    //     label: vm.$t('snapBusiness.headerV2.growth.patsnapCommunity')
                    // },
                    {
                        icon: 'SolidConversation',
                        label: vm.$t('snapBusiness.headerV2.growth.askForHelp'),
                        href: new Site({ sld: SLD.HELP, pathname: 'hc/en-us/requests/new' }).href
                    },
                    null,
                    {
                        icon: 'Term',
                        href: 'https://www.patsnap.com/legal',
                        label: vm.$t('snapBusiness.headerV2.growth.terms')
                    },
                    {
                        icon: 'Privacy',
                        href: 'https://www.patsnap.com/legal/privacy-policy',
                        label: vm.$t('snapBusiness.headerV2.growth.policy')
                    }
                ]
            };
        }
        this.headerService.right = ['slot:timer', helpCenter];

        /* 注册切换语言函数 */
        this.headerService.beforeLocaleChange = function beforeLocaleChange(localeKey, done) {
            vm.$setting.locale.setLocale(localeKey).then(() => {
                window.location.reload();
                done();
            });
        };
        /* 注册登出回调函数 */
        this.headerService.userCenterService.logoutHandler = async function logout(done, logoutHref) {
            handleLogout().then((data) => {
                const href = get(data, 'data.redirect_url', logoutHref);
                window.location.href = href;
            });
        };
    }
};
